import React from "react";
import IntroSection from "../components/Anniversary/IntroSection";
import CustomNav from "../components/Anniversary/CustomNav";
import HistorySection from "../components/Anniversary/HistorySection";
import CampaignOverviewSection from "../components/Anniversary/CampaignOverviewSection";
import CallToActionSection from "../components/Anniversary/CallToActionSection";

const AnniversaryPage = () => (
  <>
    <IntroSection />
    <CustomNav />
    <section id="history">
      <HistorySection />
    </section>
   
    <section id="campaign">
      <CallToActionSection />
    </section>

    <section id="cta">
      <CallToActionSection />
    </section>
  </>
);

export default AnniversaryPage;
